export default "__VITE_ASSET__YW15UEDU__"